import { useContext, useState } from "react";
import { Button } from "@mui/material";
import ModalContext from "../../../context/ModalContext";
import { deletePost } from "../../blogApi";

const DeleteBlogModal = ({ modalDetails }) => {
  const modalCtx = useContext(ModalContext);
  const [error, setError] = useState(null);

  const handleCloseModal = () => modalCtx.closeModal();

  const deleteBlog = () => {
    if (!modalDetails?.slug) return;
    setError(null);

    deletePost(modalDetails.slug)
      .then(() => {
        modalCtx.setPageUpdate({ page: "Blogs" });
        modalCtx.closeModal();
      })
      .catch((err) => {
        console.error(err);
        setError(err.message);
      });
  };

  return (
    <div className="create-devotional-container">
      <div className="devotional-header"><h1>Delete Blog</h1></div>
      <div className="body-container create-container">
        <span>Are you sure you want to delete {modalDetails?.title ? `“${modalDetails.title}”` : "this Blog"}?</span>
        {error ? <p style={{ color: "#d32f2f", fontSize: "0.85rem" }}>{error}</p> : null}
      </div>
      <div className="footer-devotional">
        <Button style={{ color: "#555" }} onClick={handleCloseModal}>No</Button>
        <Button style={{ color: "#555" }} onClick={deleteBlog}>Yes</Button>
      </div>
    </div>
  );
};

export default DeleteBlogModal;
